module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_31.c35511a8.png";